import React, { Component } from "react";
import { Container } from "reactstrap";
import { RouterProps, Styled } from "../../../../toolkit/decorators/Artifact";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import {
  Inputs,
  Buttons,
  formConfig,
  selectClubFormConfig
} from "./ReporteLider.form";
import { MemoTable } from "./ReporteLider.table";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import FormBuilderModal from "../../common/formBuilderModal/formBuilderModal";
// COMENTADO: Funcionalidad de cambio de vendedor deshabilitada
// import { cambiarVendedorFormConfig } from "./ReporteLiderVendedor.form";
import { gestionFormConfig } from "./ReporteLiderGestion.form";
import { ReporteLiderDispatcher } from "../../../containers/comisionesAnualidad/reporteLider/ReporteLider.dispatcher";
import { ReporteLiderStore } from "../../../containers/comisionesAnualidad/reporteLider/ReporteLider.store";
import AnualidadSnapshot from "../../../../types/AnualidadSnapshot";
import {
  errorNotification,
  infoNotification,
  successNotification
} from "../../../../utils/notifications";
import { Preview } from "../../../../types/IAction";
import {
  GetSnapshot,
  GetLiderClubes
} from "../../../reducers/comisionAnualidad";
import {
  downloadSnapshotByAsesor,
  downloadSnapshotByFolioFactura,
  downloadSnapshotByPeriodo,
  downloadSnapshotByLiderClub
} from "../../../actions/comisionAnualidad";
import ConfirmModal from "../../common/confirmModal/confirmModal";
import s from "./styles.scss";

interface Props
  extends ReporteLiderDispatcher,
    ReporteLiderStore,
    RouterProps {}

interface State {
  downloading: boolean;
  tipoBusqueda: string;
  filters: Inputs & {
    periodo: string;
    page: number;
    size: number;
  };

  row: AnualidadSnapshot;
  actualizarPopupOpen: boolean;
  // COMENTADO: Funcionalidad de cambio de vendedor deshabilitada
  // cambiarVendedorPopupOpen: boolean;
  descartarPopupOpen: boolean;
  selectClubOpen: boolean;
  clubOptions: { value: number; label: string }[];
  idLider: number;
}

@Styled(s)
export default class ReporteLiderComponent extends Component<Props, State> {
  state = {
    downloading: false,
    tipoBusqueda: "",
    filters: {
      periodo: null,
      page: 0,
      size: 100
    } as any,
    currentResumen: null,

    row: null as AnualidadSnapshot,
    actualizarPopupOpen: false,
    // COMENTADO: Funcionalidad de cambio de vendedor deshabilitada
    // cambiarVendedorPopupOpen: false,
    descartarPopupOpen: false,
    selectClubOpen: false,
    clubOptions: [],
    idLider: null
  };

  componentDidMount(): void {
    this.props.clearSnapshot();
    this.props.clearResumen();
  }

  clear = () => {
    this.setState({
      tipoBusqueda: "",
      filters: {
        page: 0,
        size: 100
      } as any
    });
  };

  fetchData = async () => {
    const { tipoBusqueda, filters } = this.state;

    let preview: Preview<GetSnapshot>;

    if (!tipoBusqueda) {
      preview = await this.props.getSnapshotByPeriodo(
        filters.periodo,
        filters.idClub,
        filters.soloContactCenter,
        filters.conCambios,
        filters.evaluadorModifico,
        0,
        10000
      );
    } else if (tipoBusqueda === "factura") {
      preview = await this.props.getSnapshotByFolioFactura(
        filters.folioFactura,
        0,
        10000
      );
    } else {
      preview = await this.props.getSnapshotByAsesor(
        filters.periodo,
        filters.idVendedor,
        0,
        10000
      );
    }

    if (!preview.fulfilled) {
      errorNotification(preview.gettingSnapshotError);
    }
  };

  generarSnapshot = async () => {
    infoNotification("Generando Snapshot...");

    const now = new Date();
    now.setDate(now.getDate() - 2);

    const periodo = new Date(now.getFullYear(), now.getMonth(), 1)
      .toISOString()
      .slice(0, 10);
    const preview = await this.props.postSnapshotByPeriodo(periodo);

    if (preview.fulfilled) {
      successNotification("El snapshot se generó correctamente");
      this.fetchData();
    } else {
      errorNotification(preview.postingSnapshotByPeriodoError);
    }
  };

  submit = async (data: { [key in Inputs]: any }) => {
    const periodo = `${data.anio || new Date().getFullYear()}-${data.mes}-01`;
    const idLider = data.idLider ? parseInt(data.idLider as any) : undefined;

    // Si no es búsqueda por periodo, usar la lógica anterior
    if (data.tipoBusqueda) {
      this.setState(
        {
          tipoBusqueda: data.tipoBusqueda,
          filters: {
            ...data,
            periodo,
            page: 0,
            size: 100
          } as any
        },
        () => this.fetchData()
      );
      return;
    }

    // Búsqueda por periodo: verificar clubes del líder
    this.setState({ idLider });

    const preview: Preview<GetLiderClubes> = await this.props.getClubesByLider(
      periodo,
      idLider
    );

    if (!preview.fulfilled) {
      errorNotification(preview.gettingLiderClubesError);
      return;
    }

    const clubes: any[] = preview.liderClubes || [];

    if (clubes.length === 0) {
      return;
    }

    if (clubes.length === 1) {
      // Un solo club: cargar directamente
      this.fetchReporte(periodo, clubes[0].idClub, data);
      return;
    }

    // Más de un club: mostrar popup de selección
    this.setState({
      selectClubOpen: true,
      clubOptions: clubes.map(c => ({ value: c.idClub, label: c.club })),
      filters: {
        ...data,
        periodo,
        page: 0,
        size: 100
      } as any
    });
  };

  fetchReporte = async (periodo: string, idClub: number, formData: any) => {
    this.setState(
      {
        tipoBusqueda: "",
        filters: {
          ...formData,
          periodo,
          idClub,
          page: 0,
          size: 100
        } as any
      },
      () => this.fetchData()
    );
  };

  handleSelectClub = (data: { idClub: any }) => {
    const { filters } = this.state;
    this.setState({ selectClubOpen: false });
    this.fetchReporte(filters.periodo, parseInt(data.idClub as any), filters);
  };

  handleExport = async () => {
    const { tipoBusqueda, filters, idLider } = this.state;
    this.setState({ downloading: true });

    if (!tipoBusqueda) {
      // Si hay idClub en los filtros, es una búsqueda de líder comercial
      if (filters.idClub) {
        downloadSnapshotByLiderClub(
          filters.periodo,
          filters.idClub,
          idLider,
          filters.soloContactCenter,
          filters.conCambios,
          filters.evaluadorModifico,
          () => this.setState({ downloading: false })
        );
      } else {
        downloadSnapshotByPeriodo(
          filters.periodo,
          filters.idClub,
          filters.soloContactCenter,
          filters.conCambios,
          filters.evaluadorModifico,
          () => this.setState({ downloading: false })
        );
      }
    } else if (tipoBusqueda === "factura") {
      downloadSnapshotByFolioFactura(filters.folioFactura, () =>
        this.setState({ downloading: false })
      );
    } else {
      downloadSnapshotByAsesor(filters.periodo, filters.idVendedor, () =>
        this.setState({ downloading: false })
      );
    }
  };

  handleActualizarSnapshot = (row: AnualidadSnapshot) => {
    this.setState({
      actualizarPopupOpen: true,
      row: row
    });
  };

  handleActualizarSubmit = async data => {
    const { row } = this.state;
    const preview = await this.props.putSnapshotEvaluacion(
      row.idCotizacionItem,
      {
        modo: data.modo,
        observaciones: data.observaciones,
        idClubModificado: data.idClubModificado
          ? parseInt(data.idClubModificado as any)
          : null,
        precioVentaModificado: data.precioVentaModificado
          ? parseFloat(data.precioVentaModificado as any)
          : null
      }
    );

    if (preview.fulfilled) {
      successNotification("La anualidad se configuró correctamente");

      this.setState({
        actualizarPopupOpen: false,
        row: null
      });
      this.fetchData();
    } else {
      errorNotification(preview.puttingSnapshotEvaluacionError);
    }
  };

  // COMENTADO: Funcionalidad de cambio de vendedor deshabilitada
  // Descomentar si se requiere esta funcionalidad en el futuro
  /*
  handleCambiarVendedor = (row: AnualidadSnapshot) => {
    this.setState({
      row,
      cambiarVendedorPopupOpen: true
    });
  };

  handleCambiarVendedorSubmit = async data => {
    const { row } = this.state;
    const preview = await this.props.putCambiarVendedor(row.idCotizacionItem, {
      idVendedor: parseInt(data.idVendedor as any),
      razonCambioVendedor: data.razonCambioVendedor
    });

    if (preview.fulfilled) {
      successNotification("Vendedor actualizado correctamente");

      this.setState({
        cambiarVendedorPopupOpen: false,
        row: null
      });
      this.fetchData();
    } else {
      errorNotification(preview.puttingCambiarVendedorError);
    }
  };
  */

  handleDescartarCambios = (row: AnualidadSnapshot) => {
    this.setState({
      row,
      descartarPopupOpen: true
    });
  };

  handleDescartarConfirm = async () => {
    const { row } = this.state;
    const result = await this.props.deleteSnapshotEvaluacion(
      row.idCotizacionItem
    );

    if (result.fulfilled) {
      successNotification("Los cambios se descartaron correctamente");

      this.setState({
        descartarPopupOpen: false,
        row: null
      });
      this.fetchData();
    } else {
      errorNotification(result.deletingSnapshotEvaluacionError);
    }
  };

  render() {
    const {
      row,
      actualizarPopupOpen,
      // COMENTADO: Funcionalidad de cambio de vendedor deshabilitada
      // cambiarVendedorPopupOpen,
      descartarPopupOpen,
      selectClubOpen,
      clubOptions
    } = this.state;

    const dynamicSelectClubConfig = {
      ...selectClubFormConfig,
      inputs: selectClubFormConfig.inputs.map(input =>
        input.name === "idClub"
          ? { ...input, props: { ...input.props, data: clubOptions } }
          : input
      )
    };

    return (
      <Container>
        <FormBuilder<Inputs, Buttons>
          config={formConfig}
          submit={this.submit}
          processing={
            this.props.gettingSnapshot ||
            this.props.gettingResumenSnapshot ||
            this.props.postingSnapshotByPeriodo ||
            this.state.downloading
          }
        >
          <IButtonBuilder
            name="generarSnapshot"
            disabled={
              this.props.gettingSnapshot ||
              this.props.gettingResumenSnapshot ||
              this.props.postingSnapshotByPeriodo ||
              this.state.downloading
            }
            onClick={this.generarSnapshot}
          />
        </FormBuilder>

        {this.props.snapshot && (
          <MemoTable
            page={this.props.snapshot}
            loading={
              this.props.gettingSnapshot ||
              this.props.gettingResumenSnapshot ||
              this.props.postingSnapshotByPeriodo ||
              this.state.downloading
            }
            onExport={this.handleExport}
            // COMENTADO: Funcionalidad de cambio de vendedor deshabilitada
            // onCambiarVendedor={this.handleCambiarVendedor}
          />
        )}

        <FormBuilderModal
          isOpen={actualizarPopupOpen}
          title={`Actualizar Cotización ${!!row && row.idCotizacionItem}`}
          message={""}
          ok={this.handleActualizarSubmit}
          cancel={() => this.setState({ actualizarPopupOpen: false })}
          formConfig={gestionFormConfig}
          values={{
            modo: (row && row.modo) || "",
            observaciones: (row && row.observaciones) || "",
            idClubModificado: (row && row.idClubModificado) || "",
            precioVentaModificado: (row && row.precioVentaModificado) || ""
          }}
        />

        {/* COMENTADO: Modal de cambio de vendedor deshabilitado
        <FormBuilderModal
          isOpen={cambiarVendedorPopupOpen}
          title={`Vendedor de Cotización ${!!row && row.idCotizacionItem}`}
          message={""}
          ok={this.handleCambiarVendedorSubmit}
          cancel={() => this.setState({ cambiarVendedorPopupOpen: false })}
          formConfig={cambiarVendedorFormConfig}
          values={{
            idVendedor: (row && row.idVendedor) || "",
            razonCambioVendedor: (row && row.razonCambioVendedor) || ""
          }}
        />
        */}

        <ConfirmModal
          isOpen={descartarPopupOpen}
          title={`Reestablecer Cotización ${!!row && row.idCotizacionItem}`}
          message={"Los cambios detectados y sus comentarios serán ignorados."}
          ok={this.handleDescartarConfirm}
          cancel={() => this.setState({ descartarPopupOpen: false })}
          size={"md"}
          waiting={this.props.deletingSnapshotEvaluacion}
        />

        <FormBuilderModal
          isOpen={selectClubOpen}
          title="Seleccione el Club"
          message="El líder tiene asignados varios clubes en el periodo. Seleccione el club que desea consultar."
          ok={this.handleSelectClub}
          cancel={() => this.setState({ selectClubOpen: false })}
          formConfig={dynamicSelectClubConfig as any}
          values={{ idClub: "" }}
        />
      </Container>
    );
  }
}
